import React from 'react';
import { classes, StyledButton } from './GridActionButton.styles';
import { GridActionButtonProps } from './GridActionButton.types';



const GridActionButton = ({ onClick, label, ...restProps }: GridActionButtonProps) => (
  <StyledButton
    className={classes.root}
    color="secondary"
    id="grid-action-btn"
    onClick={onClick}
    variant="contained"
    {...restProps}>
    {label}
  </StyledButton>
);

export default GridActionButton;
